import { useCallback, useEffect, useState } from 'react';

import { PlacedAnnotationSchema } from '@plangrid/scribble-client';

import { RelationshipType } from '../helpers/consts';
import { getBaseEntityAnnotations } from '../helpers/scribbleApiClient';
import { filterMarkupsByEntity } from '../helpers/utils';

interface FetchDocMarkupsProps {
  projectId: string;
  entityVersionId: string;
  sourceEntityId?: string;
  sourceEntityType?: string;
}

export const fetchDocMarkups = async ({
  projectId,
  entityVersionId,
  sourceEntityType,
  sourceEntityId,
}: FetchDocMarkupsProps) => {
  const markups = await getBaseEntityAnnotations(projectId, entityVersionId);
  return filterMarkupsByEntity(
    markups.data || [],
    sourceEntityType as RelationshipType,
    sourceEntityId,
  );
};

const useFetchMarkupsForDocs = ({
  projectId,
  entityVersionId,
  sourceEntityId,
  sourceEntityType,
}: FetchDocMarkupsProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [markups, setMarkups] = useState<PlacedAnnotationSchema[]>([]);

  const fetchMarkups = useCallback(async () => {
    const markups = await fetchDocMarkups({
      projectId,
      entityVersionId,
      sourceEntityId,
      sourceEntityType,
    });
    setMarkups(markups);
    setIsLoading(false);
  }, [projectId, entityVersionId, sourceEntityId, sourceEntityType]);

  useEffect(() => {
    fetchMarkups();
  }, [fetchMarkups]);
  return { isLoading, markups };
};

export default useFetchMarkupsForDocs;
